import { render, staticRenderFns } from "./ServicerSelector.vue?vue&type=template&id=5d5beb56"
import script from "./ServicerSelector.ts?vue&type=script&lang=ts&external"
export * from "./ServicerSelector.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/PortfolioWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d5beb56')) {
      api.createRecord('5d5beb56', component.options)
    } else {
      api.reload('5d5beb56', component.options)
    }
    module.hot.accept("./ServicerSelector.vue?vue&type=template&id=5d5beb56", function () {
      api.rerender('5d5beb56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientScripts/Components/ServicerSelector/ServicerSelector.vue"
export default component.exports